export default "__VITE_ASSET__DXFeDxWe__"